import type { FinancialModuleConfig } from "@/features/financialShared";

export const MonthlyTransactionItemType = {
	DEBIT: "DEBIT",
	CREDIT: "CREDIT",
} as const;

export type MonthlyTransactionItemTypeValue =
	(typeof MonthlyTransactionItemType)[keyof typeof MonthlyTransactionItemType];

export interface MonthlyUnitListItem {
	id: string;
	unitCode: string;
	ownerName: string;
	ownerEmail: string;
	reportId: string;
	debit: number;
	credit: number;
	balance: number | null;
	balanceDisplay?: string;
	balanceDueDate: string;
	canView?: boolean;
	canEdit?: boolean;
}

export interface MonthlyResumeLine {
	id: string;
	label: string;
	amount: number;
	tone?: "default" | "total" | "paid" | "balance";
}

export interface MonthlyLedgerRow {
	id: string;
	date: string;
	dateIso: string;
	invoiceNumber: string;
	code: number;
	concept: string;
	itemType: MonthlyTransactionItemTypeValue;
	debit: number | null;
	credit: number | null;
	balance: number;
	notes: string;
}

export interface MonthlyStatementOwner {
	name: string;
	email: string;
	phone: string;
	initials: string;
	unitNumber?: string;
}

export interface MonthlyUnitDetail {
	id: string;
	statementId: string;
	propertyId: string;
	periodId: string;
	propertyName: string;
	reportId: string;
	unitCode: string;
	ownerName: string;
	ownerInitials: string;
	ownerPhone: string;
	ownerEmail: string;
	unitDetail: string;
	owners: MonthlyStatementOwner[];
	servicePeriodLabel: string;
	statementDate: string;
	balanceDueDate: string;
	balanceDueDateIso: string;
	currency: string;
	resumeRows: MonthlyResumeLine[];
	resumeLines: MonthlyResumeLine[];
	totalDue: number;
	totalPaid: number;
	totalDueLabel: string;
	totalPaidLabel: string;
	ledgerRows: MonthlyLedgerRow[];
	finalBalance: number;
	finalBalanceDisplay: string;
	transactionCount: number;
	canEdit: boolean;
	canDownloadCsv: boolean;
	canDownloadPdf: boolean;
}

export const MONTHLY_MODULE_CONFIG: FinancialModuleConfig = {
	kind: "monthly",
	label: "Monthly Statement",
	basePath: "/monthly-statements",
};
